import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import config from "../../envconfig";
import StatusCustomDropdown from '../common/StatusCustomDropdown';
import axios from 'axios';
import { UserContext } from '../common/UserContext';
import { useRef } from 'react';
import Select from 'react-select';
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';


function CGMEDIT() {
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
  const [message, setMessage] = useState('');
  const { CGM_ID } = useParams();
  const [CGMEdit, setCgmEdit] = useState({
    CGM_CompanyGroupName: '', // Set default value to empty string
    CGM_CompanyGroupCode: '',
    CGM_CompanyGroupStatus: 1,
  });

  const [errors, setErrors] = useState({
    required: {
      CGM_CompanyGroupName: '',
      CGM_CompanyGroupCode: '',

    },
    other: {
      CGM_CompanyGroupName: '',
      CGM_CompanyGroupCode: '',
    },
  });
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [oldstatus, setoldstatus] = useState()
  const navigate = useNavigate()
  const toastRef = useRef(null);
  const showToast = (type, message, options = {}) => {
    if (toastRef.current && toast.isActive(toastRef.current)) {
      toast.update(toastRef.current, {
        render: message,
        type,
        autoClose: 3000,
        ...options,
      });
    } else {
      toastRef.current = toast[type](message, {
        autoClose: 3000,
        ...options,
      });
    }
  };

  // Audit Trail
  const audittransection = async (data) => {
    const formData = {
      AUTRN_ID: data.AUTRN_ID,
      AUTRN_OldValue: data.AUTRN_OldValue ?? null,
      AUTRN_NewValue: data.AUTRN_NewValue,
      AUTRN_ParamererName: data.AUTRN_ParamererName
    };
    try {
      const response = await axios.post(`${config.API_URL}/api/audittransaction`, formData);
    } catch (error) {
      if (error.response) {
        console.error('Server responded with an error:', error.response.data);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error setting up the request:', error.message);
      }
    }
  }

  const audittrailpost = async (details) => {
    const getCurrentTimestamp = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // months are zero-indexed
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const currentTimestamp = getCurrentTimestamp();
    const AUTR_OldValue = details?.AUTR_OldValue ?? null;
    const AUTR_NewValue = details?.AUTR_NewValue ?? null;
    const AUTR_Message = details.AUTR_Message;
    const AUTR_AuditType = details.AUTR_AuditType;
    if (UM_CompanyID === null || UM_CompanyID === "null" || UM_CompanyGrpID === null || UM_CompanyGrpID === "null" || selectedScpId === null || selectedScpId === "null") {
      console.log("null--------")
      const data = {
        AUTR_ScreenName: "Company Group Master Edit",
        AUTR_OldValue: AUTR_OldValue,
        AUTR_NewValue: AUTR_NewValue,
        AUTR_Message: AUTR_Message,
        AUTR_UserID: UM_UserId,
        AUTR_UserName: UM_UserCode,
        AUTR_TimeStamp: currentTimestamp,
        AUTR_AuditType: AUTR_AuditType,
        AUTR_SCPID: (selectedScpId === null || selectedScpId === "null") ? null : selectedScpId,
        AUTR_CompanyGrpId: (UM_CompanyGrpID === null || UM_CompanyGrpID === "null") ? null : UM_CompanyGrpID,
        AUTR_CompanyID: (UM_CompanyID === null || UM_CompanyID === "null") ? null : UM_CompanyID,
        AUTR_CreatedBy: UM_UserId,
        AUTR_CreatedDateTime: currentTimestamp
      };
      console.log(data)
      try {
        const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
        console.log('Success:', response.data);
        return response.data;
      } catch (error) {
        console.error('Error:', error);
      }
    } else {
      console.log("null--------")
      const data = {
        AUTR_ScreenName: "Company Group Master Edit",
        AUTR_OldValue: AUTR_OldValue,
        AUTR_NewValue: AUTR_NewValue,
        AUTR_Message: AUTR_Message,
        AUTR_UserID: UM_UserId,
        AUTR_UserName: UM_UserCode,
        AUTR_TimeStamp: currentTimestamp,
        AUTR_AuditType: AUTR_AuditType,
        AUTR_SCPID: (selectedScpId === null || selectedScpId === "null") ? null : selectedScpId,
        AUTR_CompanyGrpId: (UM_CompanyGrpID === null || UM_CompanyGrpID === "null") ? null : UM_CompanyGrpID,
        AUTR_CompanyID: (UM_CompanyID === null || UM_CompanyID === "null") ? null : UM_CompanyID,
        AUTR_CreatedBy: UM_UserId,
        AUTR_CreatedDateTime: currentTimestamp
      };
      console.log(data)
      try {
        const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
        console.log('Success:', response.data);
        return response.data;
      } catch (error) {
        console.error('Error:', error);
      }
    }

  };

  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);
    sessionStorage.setItem('selectedScpId', selectedScpId);
  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

  const logAction = async (action, isError = false) => {
    console.log(`${isError ? '[ERROR] ' : ''}${action}`);
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "Company Group Master Edit:", action, userCode: UM_UserCode, isError }),
      });

      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${config.API_URL}/CGM/toupdate/${CGM_ID}`);
        if (response.ok) {
          const data = await response.json();
          console.log('Fetched Data:', data);
          logAction("fetchData(): CGM data get by id in input Fields from API ")
          setCgmEdit(data);
          setoldstatus(data.CGM_CompanyGroupStatus)
        } else {
          console.error('Error fetching the company data');
          logAction("fetchData(): Error in  CGM data get by id in input Fields from API ")
        }
      } catch (error) {
        logAction("fetchData():Error in CGM data get by id in input Fields from API ")
        console.error('Error fetching company data:', error);
      }
    };
    fetchData(); // Call the fetchData function immediately
  }, [CGM_ID]); // Empty dependency array to run once when component mounts

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      required: { ...errors.required },
      other: { ...errors.other },
    };

    if (!CGMEdit.CGM_CompanyGroupName) {
      newErrors.required.CGM_CompanyGroupName = '*';
      valid = false;
    } else {
      newErrors.required.CGM_CompanyGroupName = '';
    }

    if (!CGMEdit.CGM_CompanyGroupCode) {
      newErrors.required.CGM_CompanyGroupCode = '*';
      valid = false;
    } else {
      newErrors.required.CGM_CompanyGroupCode = '';
    }

    setErrors(newErrors);
    return valid;
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setCgmEdit((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    let valid = true;
    const newErrors = {
      required: { ...errors.required },
      other: { ...errors.other },
    };
    setErrors(newErrors);

    if (!valid) {
      return;
    }
    setCgmEdit((prevCgmEdit) => ({
      ...prevCgmEdit,
      [name]: value,
    }));
    setMessage('');
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    // Prevent if already showing success toast
    // if (toast.isActive('save-toast')) {
    //   return;
    // }
    // toast.dismiss();

    logAction('handleUpdate():Started');

    if (!validateForm()) {
      return;
    }
    setIsLoading(true);

    const editInputvalue = {
      CGM_CompanyGroupName: CGMEdit.CGM_CompanyGroupName,
      CGM_CompanyGroupCode: CGMEdit.CGM_CompanyGroupCode,
      CGM_CompanyGroupStatus: CGMEdit.CGM_CompanyGroupStatus,
    };

    try {
      const saveData = await fetch(`${config.API_URL}/CGM/Update/${CGM_ID}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(editInputvalue),
      });

      if (saveData.ok) {
        const resjson = await saveData.json();
        setMessage(resjson.message);
        logAction(`handleUpdate(): Company Group : ${CGMEdit.CGM_CompanyGroupName} updated successfully`);
        showToast('success', `Company Group : ${CGMEdit.CGM_CompanyGroupName} updated successfully.`);
        const details = {
          AUTR_Message: `${CGMEdit.CGM_CompanyGroupName} Updated`,
          AUTR_AuditType: "update",
          AUTR_NewValue: CGMEdit.CGM_CompanyGroupStatus === 1 ? 'Active' :
            CGMEdit.CGM_CompanyGroupStatus === 2 ? 'Inactive' : 'Unknown',
          AUTR_OldValue: oldstatus.CGM_CompanyGroupStatus === 1 ? 'Active' :
            oldstatus.CGM_CompanyGroupStatus === 2 ? 'Inactive' : 'Unknown',
        };
        let id = await audittrailpost(details);

        const details1 = {
          AUTRN_ParamererName: "CompanyStatus",
          AUTRN_NewValue: CGMEdit.CGM_CompanyGroupStatus,
          AUTRN_OldValue: oldstatus,
          AUTRN_ID: id
        };
        audittransection(details1);
        setTimeout(() => {
        }, 5000);
        setTimeout(() => {
          setMessage('');
        }, 2000);

      } else {
        if (saveData.status === 400) {
          setIsLoading(false); // ✅ stop loader ONLY here

          const backendMsg = await saveData.text();

          let reason = backendMsg;
          if (backendMsg.toLowerCase().includes('because')) {
            reason = backendMsg.split('because')[1].trim();
          }

          showToast('error',
            `You cannot inactivate the Company Group : ${CGMEdit.CGM_CompanyGroupName} because ${reason}`
          );
        } else {
          showToast('error',
            `Company Group : ${CGMEdit.CGM_CompanyGroupName} could not be updated successfully.`
          );
        }

        console.error('Error in saving Data:', saveData.statusText);
        logAction('handleUpdate(): Error in saving data.', true);
      }

    } catch (error) {
      console.log('Error updating user data:', error);
      logAction("handleUpdate(): Error in catch block", true);

      const details = {
        AUTR_Message: `${CGMEdit.CGM_CompanyGroupName} Updated`,
        AUTR_AuditType: "update",
        AUTR_NewValue: CGMEdit.CGM_CompanyGroupStatus === 1 ? 'Active' :
          CGMEdit.CGM_CompanyGroupStatus === 2 ? 'Inactive' : 'Unknown',
        AUTR_OldValue: oldstatus === 1 ? 'Active' :
          oldstatus === 2 ? 'Inactive' : 'Unknown',
      };
      let id = await audittrailpost(details);

      const details1 = {
        AUTRN_ParamererName: "Company Group Status",
        AUTRN_NewValue: CGMEdit.CGM_CompanyGroupStatus === 1 ? 'Active' :
          CGMEdit.CGM_CompanyGroupStatus === 2 ? 'Inactive' : 'Unknown',
        AUTRN_OldValue: oldstatus === 1 ? 'Active' :
          oldstatus === 2 ? 'Inactive' : 'Unknown',
        AUTRN_ID: id
      };
      audittransection(details1);
      showToast('success', `Company Group : ${CGMEdit.CGM_CompanyGroupName} updated successfully.`, {
        // toastId: 'save-toast', // Add unique ID
        onClose: () => {
          setIsLoading(false); // ✅ stop loader ONLY here

          navigate(`/dashboard/companygroupmaster`);
        }
      });
    }
  };


  function generateUniqueId() {
    return 'xxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }


  const handleCancel = () => {
    setCgmEdit((prevCgmEdit) => ({
      ...prevCgmEdit,
      CGM_CompanyGroupStatus: 1,
    }));
    setMessage('');
    logAction("handleCancel(): Clear all fields data.")
  };
  const handleStatusChange = (selectedOption) => {
    setCgmEdit(prev => ({
      ...prev,
      CGM_CompanyGroupStatus: selectedOption?.value ?? 1,
    }));
  };

  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };
  return (
    <React.Fragment>
      <ToastContainer
        limit={1}
        style={{
          marginTop: '73px',
          fontSize: '14px',
          width: '40%',

        }} />
      {isLoading && (
        <div style={{
          position: 'fixed', // Sit on top of the page content
          left: 0,
          top: 0,
          width: '100%', // Full width
          height: '100%', // Full height

          zIndex: 1000 // Sit on top of the other elements
        }} />
      )}
      <form onSubmit={handleUpdate} autoComplete="off">
        <div className='main_container'>
          <h3 className='formHeading'>Company Group Master </h3>
          <div className='your-form-containe row'>
            {/* <div className='form-section'> */}
              <div className='col-md-6'>
                <label>Company Group Name
                </label>
                <input
                  type='text'
                  className='form-input'
                  name='CGM_CompanyGroupName'
                  value={CGMEdit ? CGMEdit.CGM_CompanyGroupName : ''}
                  onChange={handleInput}
                  required
                  disabled
                />
              </div>

              <div className='col-md-6'>
                <label>Company Group Code
                </label>
                <input
                  type='text'
                  className='form-input'
                  name='CGM_CompanyGroupCode'
                  value={CGMEdit ? CGMEdit.CGM_CompanyGroupCode : ''}
                  onChange={handleInput}
                  required
                  disabled
                />
              </div>
            {/* </div> */}

            <div className='form-section mt-3'>
              <div className='col-md-6 '>
                <label className='form-lable'>Company Group Status </label>
                <div className='select-container'>
                  {/* <StatusCustomDropdown
                    name='CGM_CompanyGroupStatus'
                    options={[
                      { value: 1, label: 'Active' },
                      { value: 2, label: 'Inactive' },
                    ]}
                    value={CGMEdit.CGM_CompanyGroupStatus || 1} // This should now correctly reflect '1' or '2'
                    onChange={handleInput}
                    idKey='value'
                    displayKey='label'
                    onMenuOpen={() => handleSelectOpen('CGM_CompanyGroupStatus')}
                    onMenuClose={handleSelectClose}
                  /> */}
                  <Select
                    name="CGM_CompanyGroupStatus"
                    options={[
                      { value: 1, label: 'Active' },
                      { value: 2, label: 'Inactive' },
                    ]}
                    value={[
                      { value: 1, label: 'Active' },
                      { value: 2, label: 'Inactive' },
                    ].find(opt => opt.value === CGMEdit.CGM_CompanyGroupStatus)}
                    onChange={handleStatusChange}
                    onMenuOpen={() => handleSelectOpen('CGM_CompanyGroupStatus')}
                    onMenuClose={handleSelectClose}
                    classNamePrefix="react-select"
                    isSearchable={false}

                  />
                  <div className="icon-container_list myList">
                    {isSelectOpen === "CGM_CompanyGroupStatus" ? (
                      <IoCaretUpOutline />
                    ) : (
                      <IoCaretDownOutline />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <p className='text-success'>{message}</p>
            <p className='text-danger'>{errors.duplicateMsg}</p>
          </div>
        </div>
        <div className='button-container'>

          <button type='submit' className='save_btn'>SAVE</button>
          <button
            className="reset_btn"
            type="button"
            onClick={handleCancel}
          >
            RESET
          </button>
          <Link to={`/cgmlist/`} className='list_btn' type='button'> LIST </Link>
        </div>
      </form>
    </React.Fragment>
  );
}

export default CGMEDIT;

